import React, { useState } from "react";
import { useEffect } from "react";
import {
  Bar,
  XAxis,
  YAxis,
  BarChart,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

import { Loading } from "../../webtracking/components";
import axios from "../../helpers/axios";

const CustomTooltip = ({ active, label, payload }) => {
  if (active) {
    return (
      <div style={{ padding: "1rem", background: "rgba(255,255,255,0.5)" }}>
        <p>{label}</p>
        <p>A tiempo: {payload[0].value}</p>
        <p>Retrasados: {payload[1].value}</p>
      </div>
    );
  }

  return null;
};

const GlobalEfficiency = (props) => {
  const { range } = props;

  const [data, setData] = useState([]);
  const [isLoading, setLoading] = useState(true);

  const loadData = () => {
    setLoading(true);


    let date = props.range.value
    date = date.split("-");

    const year = date[0];
    const month = Number(date[1]) + 1;

    axios
      .get(`/api/dashboard/global/?year=${year}&month=${month}`)
      .then(response => {
        setData([
          {
            name: "Eficiencia de todas las OC",
            ammount1: response.data.intime,
            ammount2: response.data.outtime,
          },
        ]);
      })
      .catch((error) => {
        console.error(error);
      })
      .then(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    loadData();
  }, [range]);

  return (
    <div className="card">
      <div className="card-content">
        <h2 className="title is-6 has-text-centered">
          Eficiencia global ({range.label})
        </h2>

        {isLoading ? (
          <Loading />
        ) : data.length ? (
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={data}>
              <XAxis dataKey="name" type="category" />
              <YAxis type="number" />
              <Tooltip content={<CustomTooltip />} />
              <Bar dataKey="ammount1" fill="#30d2d6"></Bar>
              <Bar dataKey="ammount2" fill="#ff5555"></Bar>
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <div className="hero">
            <div className="hero-body has-text-centered">
              <h1 className="title">Sin resultados</h1>
              <h2 className="subtitle">No se encontraron resultados</h2>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default GlobalEfficiency;
